// @flow
import Stopwatch from 'app/packages/trace-logger/Stopwatch';
import traceLogger from 'app/packages/trace-logger/singleton';
import { getLongTaskDurations } from 'app/packages/trace-logger/longTasks';

export default function addPageBinaryAnnotations(currTimer: ?Stopwatch) {
  if (currTimer) {
    const timer = currTimer;
    if (traceLogger.serverTraceData.binary_annotations) {
      traceLogger.serverTraceData.binary_annotations.forEach((entry) => {
        timer.addBinaryAnnotation(entry);
      });
    }

    if (window.PerformanceObserver) {
      const longTaskDurations = getLongTaskDurations();
      if (longTaskDurations.length) {
        timer.addBinaryAnnotation({
          name: 'longTaskCount',
          value: longTaskDurations.length,
          annotation_type: 'I32',
        });
        timer.addBinaryAnnotation({
          name: 'maxLongTask',
          value: Math.max(...longTaskDurations),
          annotation_type: 'I32',
        });
      }
    }
  }
}
